import { get } from 'lodash';

const handleStatusFilterRule = (rule, booking) => {
  const [propertyKey, expectedValue] = Object.entries(rule)[0];

  let propertyKeyPath = propertyKey.replace('.keyword', '');
  if (propertyKeyPath.includes('masterStatusName')) {
    // `masterStatusName` is nested in `masterStatus` in the GQL response
    propertyKeyPath = `masterStatus.${propertyKeyPath}`;
  }

  const propertyKeyValue = get(booking, propertyKeyPath, undefined);
  return propertyKeyValue === expectedValue;
};

export default function applyStatusFilter(booking, selectedStatusLabelAndRules) {
  if (!selectedStatusLabelAndRules) return true;

  const statusRules = {
    match: selectedStatusLabelAndRules.must || [],
    mismatch: selectedStatusLabelAndRules.mustNot || [],
  };
  // Some statuses are complex and require a combination of values over different fields

  const matches = statusRules.match.map((rule) => handleStatusFilterRule(rule, booking));
  // Rules that match the booking status/properties

  const mismatches = statusRules.mismatch.map((rule) => handleStatusFilterRule(rule, booking));
  // Rules that don't match the booking status/properties

  const satisfiedRules = !matches.includes(false) && !mismatches.includes(false);
  // If there are any unexpected matches or mismatches, it doesn't satisfy the rules

  return satisfiedRules;
}
